import { createAction } from '@reduxjs/toolkit';

export const setCards = createAction<any[]>('dataTableInfo/setCards');
export const setDetailedProject = createAction<any[]>('dataTableInfo/setDetailedProject');

export const setLoading = createAction<boolean>('dataTableInfo/setLoading');
export const setIndicatorResponse = createAction<any[]>('dataTableInfo/setIndicatorResponse');
export const setHomeSummaryData = createAction<any[]>('dataTableInfo/setHomeSummaryData');
export const setIndicatorLoading = createAction<boolean>('dataTableInfo/setIndicatorLoading');
